import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Logo from '../logo/nucleus'
import Img from 'gatsby-image'

export default ({ children, graphic }) => (
    <Style>
        <nav>
            <ul>
                <li>
                    <a href="https://www.nucleusinnovation.ch">Home</a>
                </li>
                <li>
                    <a href="https://www.nucleusinnovation.ch/about">About</a>
                </li>
                <li>
                    <a href="https://www.nucleusinnovation.ch/blog">Blog</a>
                </li>
                <li>
                    <a href="https://www.nucleusinnovation.ch/contact">Contact</a>
                </li>
            </ul>
        </nav>

        <Logo image={'/new-ndi-logo-lg.png'} width={196} height={41} />

        <address>
        <b>Nucleus Digital Innovation GmbH</b><br />
        Haldenstrasse 5, CH 6340 Baar (Zug), Switzerland<br /><br />
        
        <small>Registergericht: Handelsregister des Kantons Zug<br />
        Firmennummer: CHE-309.413.930</small>
        <small><b>UserCity is a registered trademark of <a href="https://www.nucleusinnovation.ch" rel="self">Nucleus Digital Innovation</a> Ltd</b></small>
        </address>

        <strong>Offices in Switzerland + the United Kingdom</strong>

        <a href="https://www.linkedin.com/company/nucleus-digital-innovation-gmbh" target="_blank" rel="noopener noreferrer external nofollow">Follow us on Linkedin</a>

        { graphic && <div className="footer__graphic"><Img Tag="figure" fluid={graphic.childImageSharp.fluid} alt={'Graphic'} /></div>}
    </Style>
)


const Style = styled.div.attrs(props => ({
    className: 'footer'
}))`
    
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-gap: 30px;

    > * {
        position: relative;
        z-index: 1;
    }

    ${breakpoint('tablet')`
        display: grid;
    `}

    nav, .logo, address {
        grid-column: 1 / 2;
    }

    > strong, > a[href*="linkedin"] {
        grid-column: 2 / 3;
        text-align: right;
    }

    nav, strong {
        grid-row: 1 / 2;
    }

    > a {
        grid-row: 2 / 3;
    }

    nav ul {
        list-style: none;
        padding: 0;
        margin: 0 0 2vh 0;
        display: flex;
        font-size: 16px;
        font-weight: 600;
        text-transform: uppercase;

        ${breakpoint('tablet')`
            margin: 0;
        `}

        > li {
            margin-right: 1em;
        }

        a {
            color: var(--textColor);
            line-height: 1.85;
            text-decoration: none;
            padding-bottom: .15em;
            border-bottom: 4px var(--red) solid;

            &:hover, &:focus {
                color: var(--red);
            }
        }
    }  

    address { 
        font-size: 13px;
        font-style: normal;
        line-height: 1.4;
        margin: 2vh 0 2vh 0;

        ${breakpoint('tablet')`
            margin: 0;
        `}

        small {
            font-size: 9px;
            display: block;

            + small {
                margin-top: 1em;
            }

            a {
                color: var(--red);
            }
        }
    }

    > strong {
        font-size: 14px;
    }

    a[href*="linkedin"] {
        width: 111px;
        height: 44px;
        background-image: url('/linkedin.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        margin-top: 2vh;
        text-indent: -5000em;
        text-align: left;
        display: block;

        ${breakpoint('tablet')`
            margin-left: auto;
            margin-top: 0;
        `}

        &:hover, &:focus {
            opacity: .75
        }
    }

    .footer__graphic {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        max-width: 190px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        display: none;

        ${breakpoint('tablet')`
            display: flex;
        `}
    }

    figure {
        margin: 0;

        img {
            margin-bottom: 0;
        }
    }
`